<template>
  <nav id="tf-menu" class=" navbar navbar-default navbar-fixed-top">
    <div class="container">
      <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand" href="/work" v-text="title"></a>
        </div>

      <!-- Collect the nav links, forms, and other content for toggling -->
      <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
        <ul class="nav navbar-nav navbar-right">
          <li><a href="/work" class="page-scroll">首页</a></li>
          <li><a href="#tf-services" class="page-scroll" v-show="pathname === '/work'">四旋翼赛事</a></li>
          <li><a href="#services" class="page-scroll" v-show="pathname === '/work'">无人机设计</a></li>
          <li><a href="#tf-clients" class="page-scroll" v-show="pathname === '/work'">MBSE数字孪生</a></li>
          <!-- <li class="dropdown">
            <a href="javascript:void(0);"  data-toggle="dropdown" id="dLabel" aria-haspopup="true" aria-expanded="true">&nbsp;赛事活动<span class="caret"></span>&nbsp;</a>
            <ul class="dropdown-menu dropdown-menu-left haha" aria-labelledby="dLabel">
              <li class="menu-item "><a href="/work/download?tyep=UAV">无人机大赛</a></li>
            </ul>
          </li> -->
          <li><a href="#tf-contact" class="page-scroll" v-show="pathname === '/work'">商务合作</a></li>
          <li><a href="javascript:void(0);" class="page-scroll" @click="goLogin">登录</a></li>
        </ul>
      </div><!-- /.navbar-collapse -->
    </div><!-- /.container-fluid -->
  </nav>
</template>
<script>
function main() {
   'use strict';

  var $ = window.$

  /* ==============================================
  Testimonial Slider
  =============================================== */ 

  $('a.page-scroll').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html,body').animate({
            scrollTop: target.offset().top - 40
          }, 900);
          return false;
        }
      }
    });

  /*====================================
  Show Menu on Book
  ======================================*/
  $(window).bind('scroll', function() {
      var navHeight = $(window).height() - 100;
      if ($(window).scrollTop() > navHeight) {
          $('.navbar-default').addClass('on');
      } else {
          $('.navbar-default').removeClass('on');
      }
  });

  $('body').scrollspy({ 
      target: '.navbar-default',
      offset: 80
  })

}
export default {
  name: 'h-header',
  data () {
    return {
      pathname: window.location.pathname
    }
  },
  props: {
    title: {
      type: String,
      default: "无人机数字孪生实验室"
    },
  },
  created () {
  },
  mounted () {
    main()
  },
  methods: {
    goLogin () {
      this.$router.push(`/work/login?backUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`)
    }
  }
}
</script>
<style scoped lang="scss">
@import 'index';
</style>
